
import { Aeroespecialidad } from "./aeroespecialidad";
import { Comparativa } from "./Comparativa";
import { ComparativaExpendedora } from "./ComparativaExpendedora";
import { MedicionTanque } from "./MedicionTanque";
import { ParteDiario } from "./ParteDiario";
import { Precierre } from "./Precierre";
import { Aeroplanta } from "./Aeroplanta";
import { TotalProducto } from "./TotalProducto";

export class CierreTurno{
    id: string;
    numero: number;
    estadoCierre: number;
    fechaHora: string;
    fechaHoraCierre: string;
    fechaHoraFinalizacion: string;
    aeroplanta: Aeroplanta;
    responsable:string;
    medicion
    medicionesTanques: MedicionTanque[];
    medicionesFueronCargadas: boolean;
    efectivo: number;
    aeroespecialidades: Aeroespecialidad[];
    precierres: Precierre[];
    comparativas: Comparativa[];
    comparativasExpendedoras: ComparativaExpendedora[];
    totalesProductos: TotalProducto[];
    fechaHoraReportes: string;
    parteDiario: ParteDiario;
    etapaActual: number;
}